export const asRem = (px: number) => `${px / 16}rem`;
